import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import BadgeDTO from "../dto/BadgeDTO";
import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import Badge from "../models/Badge";

class BadgeService extends GenericCrudServiceV2<Badge> {
  constructor(protected basePath: string) {
    super(basePath);
  }

  getFormData(badge: Badge): FormData {
    const formData = new FormData();

    formData.append("dto", JSON.stringify(badge));

    return formData;
  }

  getBadgesForOpsUserExternalId(opsUserExternalId: string): Promise<ApiResponse<BadgeDTO[]>> {
    return HttpClient.get(`${this.basePath}/ops-user/${opsUserExternalId}`);
  }

  getBadgesPagedForOpsUser(page: number, pageSize: number, opsUserExternalId: string): Promise<ApiResponseV2<PagedResult<BadgeDTO>>> {
    return HttpClientV2.get(`${this.basePath}/ops-user/paged/${opsUserExternalId}?page=${page}&pageSize=${pageSize}`);
  }

  getAvailableBadgesForOpsUser(): Promise<ApiResponse<BadgeDTO[]>> {
    return HttpClient.get(`${this.basePath}/available`);
  }

  getBadgeFilter(page: number, pageSize: number, name: string): Promise<ApiResponseV2<PagedResult<Badge>>> {
    let url = `${this.basePath}/all-badge?page=${page}&pageSize=${pageSize}&name=${name}`;
    return HttpClientV2.get(url);
  }

  findAllBadgesNames(active: boolean): Promise<ApiResponseV2<AutoCompleteUIDTO[]>> {
    return HttpClientV2.get(`${this.basePath}/badges-names?active=${active}`);
  }

  editBadge(badge: Badge): Promise<ApiResponseV2<Badge>> {
    return HttpClientV2.put(`${this.basePath}/update/${badge.externalId}`, this.getFormData(badge));
  }

  changeBadgeStatus(externalId: string, enable: boolean): Promise<ApiResponseV2<Badge>> {
    return HttpClientV2.put(`${this.basePath}/${externalId}/change-status?enable=${enable}`, {});
  }
}

export default new BadgeService("/badges");
